import { useCallback } from 'react';
import {
  CreditCardAccessType as CreditCardAccessTypeV1,
  CreditCardAccessCardAccessEntityCentralCardAccessLevel,
} from '../../types/api/v1/common/card';
import { CreditCardAccessType } from '../../types/api/v2/obt/model/credit-card-access-type';

interface IUseCardAccessFunction {
  selectedItemIds?: string[];
  areAllItemsSelected?: boolean;
  organizationId?: string;
}

type IUseCardAccessFunctionResult =
  | {
      cardAccess: {
        accessType: CreditCardAccessTypeV1;
        entityIds: string[];
        entities?: {
          entityId: string;
          centralCardAccessLevel: CreditCardAccessCardAccessEntityCentralCardAccessLevel;
        }[];
      };
    }
  | undefined;

interface IUseCardAccess {
  cardAccessType?: CreditCardAccessType;
}

type IUseCardAccessResult = (data: IUseCardAccessFunction) => IUseCardAccessFunctionResult;

const useCardAccess = ({ cardAccessType }: IUseCardAccess): IUseCardAccessResult => {
  return useCallback(
    ({
      selectedItemIds,
      areAllItemsSelected,
      organizationId,
    }: IUseCardAccessFunction): IUseCardAccessFunctionResult => {
      if (cardAccessType === CreditCardAccessType.Tmc) {
        return {
          cardAccess: {
            accessType: CreditCardAccessTypeV1.TMC,
            entityIds: [],
            entities: organizationId
              ? [
                  {
                    entityId: organizationId,
                    centralCardAccessLevel: CreditCardAccessCardAccessEntityCentralCardAccessLevel.TMC,
                  },
                ]
              : [],
          },
        };
      }

      if (cardAccessType === CreditCardAccessType.Centralised) {
        if (areAllItemsSelected || !selectedItemIds?.length) {
          return organizationId
            ? {
                cardAccess: {
                  accessType: CreditCardAccessTypeV1.CENTRALISED,
                  entityIds: [],
                  entities: [
                    {
                      entityId: organizationId,
                      centralCardAccessLevel: CreditCardAccessCardAccessEntityCentralCardAccessLevel.ORGANIZATION,
                    },
                  ],
                },
              }
            : undefined;
        }

        return {
          cardAccess: {
            accessType: CreditCardAccessTypeV1.CENTRALISED,
            entityIds: [],
            entities: selectedItemIds.map((legalEntityId) => ({
              entityId: legalEntityId,
              centralCardAccessLevel: CreditCardAccessCardAccessEntityCentralCardAccessLevel.LEGAL_ENTITY,
            })),
          },
        };
      }

      return undefined;
    },

    // TODO: FIX_ESLINT_VIOLATION
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );
};

export default useCardAccess;
